module.exports = __webpack_public_path__ + "img/17.01b66165.jpg";